import React from 'react';
import './NoItems.scss';
import Logo from '../../../assets/images/companies/logo.png';
import {ButtonMUI} from '../../../shared';
import {ReactComponent as PlusIcon} from '../../../assets/icons/plus.svg';

const NoItems = ({title, description, handleNavigate, buttonText, center, disabled = false}) => {
  return (
    <div className={`no-items-block ${center ? 'center' : ''}`}>
      <img src={Logo} alt='image' />
      <h3>{title}</h3>
      {buttonText && !disabled && (
        <>
          <p>{description}</p>
          <ButtonMUI color={'primary'} startIcon={<PlusIcon />} fullWidth={true} onClick={handleNavigate}>
            {buttonText}
          </ButtonMUI>
        </>
      )}
    </div>
  );
};

export default NoItems;
